import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "src/app/services/Auth/auth.service";

export const forceUpdateGuard: CanActivateFn = (route, state) => {
  return inject(AuthService).forceChange() ? inject(Router).createUrlTree(['/password_update']) : true  ;
};
